import { cookie } from "@otto-ec/global-resources/cookie";
import { exactagScope } from "../core/utils";

const log = exactagScope.scope("observability.benchmark");

/**
 *
 */
export const benchmarkData = {
  enabled: false,
  startTime: 0,
  endTime: 0,
  timeSinceDomeReady: 0,
};

/**
 *
 *
 */
export function startBenchmark(): number {
  /*                                                                                            */
  if (!benchmarkData.enabled) return 0;
  benchmarkData.startTime = new Date().getTime();
  log.info("Benchmark started.", benchmarkData.startTime);
  return benchmarkData.startTime;
}

/**
 *
 */
export function getBenchmarkResult(): string {
  if (!benchmarkData.enabled) return "Benchmark is not enabled.";
  return `Exactag completed ${benchmarkData.timeSinceDomeReady} seconds after init.`;
}

/**
 *
 *
 */
export function enableBenchmark(enabled = true): void {
  benchmarkData.enabled = enabled;
}

/**
 *
 *
 */
export function endBenchmark(): number {
  /*                                                                                                         */
  if (!benchmarkData.enabled) return 0;

  benchmarkData.endTime = new Date().getTime();
  benchmarkData.timeSinceDomeReady = (benchmarkData.endTime - benchmarkData.startTime) / 1000;
  log.info(getBenchmarkResult());
  return benchmarkData.endTime;
}

/**
 *
 *
 */
export function updateBenchmarkEnabled(): boolean {
  benchmarkData.enabled =
    location.href.indexOf("#benchmark") > -1 ||
    cookie.get("PartnerPixelBenchmark") === "PixelBenchmark=true";

  log.info("Benchmark enabled:", benchmarkData.enabled);
  return benchmarkData.enabled;
}
